import { render, staticRenderFns } from "./RecordsPanel.vue?vue&type=template&id=b8ceda40"
import script from "./RecordsPanel.vue?vue&type=script&lang=js"
export * from "./RecordsPanel.vue?vue&type=script&lang=js"
import style0 from "./RecordsPanel.vue?vue&type=style&index=0&id=b8ceda40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports